module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/fpceuc-9c3af31b7af10b46d7c97213aba44275.svg";